<template>
  <!-- eslint-disable -->
  <div>
    <usuarios-add :is-add.sync="isAdd" ref="userAdd"> </usuarios-add>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Nombre</label>
            <b-form-input v-model="fullname" placeholder="Nombre" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Documento</label>
            <b-form-input v-model="document" placeholder="Documento" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Correo</label>
            <b-form-input v-model="email" placeholder="Correo" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Rol</label>
            <v-select
             v-model="role"
             :options="roles"
             label="name"
             placeholder="Rol"
             @input="filter"/>
          </b-col>
          <b-col md="2" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>

          <b-col class="d-flex align-items-center justify-content-end">
          <!-- @click="isAddNewUserSidebarActive = true"< -->
          <b-button variant="primary" class="mt-2" @click="addUser">
            <span class="text-nowrap">Agregar elemento</span>
          </b-button>
        </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import usuariosAdd from './usuariosAdd.vue'
import RolesService from '@/services/RolesService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      fullname: '',
      document: '',
      email: '',
      arrayFilters: [],
      extraFilters: [],
      role: null,
      roles: []
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    usuariosAdd
  },
  mounted() {
    this.getExtraData();
  },
  methods: {
    async getExtraData(){
      const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.extraFilters)}`;
      const respRole = await RolesService.getRoles(url, this.$store);
      if (respRole) {
        this.roles = respRole.data.rows;
      }
    },

    addUser(){
      this.isAdd = true
      this.$refs.userAdd.getData({})
      // this.$refs.userAdd.getLocals()
    },
    async filter() {
      this.arrayFilters = [];
      if (this.fullname !== '') {
        this.arrayFilters.push({
          keyContains: 'fullname',
          key: 'contains',
          value: this.fullname
        });
      }

        if (this.document !== '') {
        this.arrayFilters.push({
          keyContains: 'document',
          key: 'contains',
          value: this.document
        });
      }

      if (this.email !== '') {
        this.arrayFilters.push({
          keyContains: 'email',
          key: 'contains',
          value: this.email
        });
      }

      if (this.role !== '' && this.role !== null) {
        this.arrayFilters.push({
          keyContains: 'role.name',
          key: 'contains',
          value: this.role.name
        });
      }
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.fullname = '';
      this.document = '';
      this.email = '';
      this.role = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
